import { render, staticRenderFns } from "./btnDialog.vue?vue&type=template&id=81320d66"
import script from "./btnDialog.vue?vue&type=script&lang=js"
export * from "./btnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports